import { Component, type ErrorInfo, type ReactNode } from 'react'
import { AlertTriangle, RefreshCw } from 'lucide-react'
import { Button } from '@/components/ui/button'

interface Props {
  children: ReactNode
}

interface State {
  hasError: boolean
  message: string | null
}

export class AppErrorBoundary extends Component<Props, State> {
  override state: State = { hasError: false, message: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, message: error.message || 'Erro inesperado na interface.' }
  }

  override componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('AppErrorBoundary capturou um erro de renderização.', error, errorInfo)
  }

  override render() {
    if (!this.state.hasError) return this.props.children

    return (
      <div className="flex min-h-screen items-center justify-center bg-background p-6">
        <div className="w-full max-w-lg rounded-xl border border-amber-200/70 bg-amber-50/60 p-6 text-center dark:border-amber-900/50 dark:bg-amber-950/20">
          <span className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/40">
            <AlertTriangle className="h-5 w-5 text-amber-700 dark:text-amber-400" aria-hidden />
          </span>
          <h1 className="mt-4 text-base font-semibold">A interface encontrou um erro</h1>
          <p className="mt-2 text-sm text-muted-foreground">
            Recarregue a página. Se o problema persistir, informe a mensagem abaixo ao suporte.
          </p>
          {this.state.message ? (
            <p className="mt-3 rounded-lg bg-background/70 p-3 font-mono text-xs text-muted-foreground">
              {this.state.message}
            </p>
          ) : null}
          <div className="mt-5 flex justify-center">
            <Button variant="outline" onClick={() => window.location.reload()}>
              <RefreshCw className="h-4 w-4" aria-hidden />
              Recarregar página
            </Button>
          </div>
        </div>
      </div>
    )
  }
}
